<template>
  <div class="bg" aria-modal="true" role="dialog">
    <div class="card">
      <div class="row">
        <Spinner class="spinner" />
        <div class="text">
          <div class="title">Uploading report…</div>
          <div class="subtitle">
            Sending logs to help the team fix the issue. This can take a few
            seconds.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Spinner from "@/components/Spinner.vue";

export default defineComponent({
  components: { Spinner },
});
</script>

<style scoped lang="scss">
.bg {
  position: fixed;
  inset: 0;
  z-index: $z-index-critical;
  display: flex;
  align-items: center;
  justify-content: center;

  @include themed() {
    background: t($bg-overlay);
  }
}

.card {
  width: min(420px, calc(100% - 48px));
  border-radius: $border-radius-l;
  box-shadow: $console;
  padding: 20px 24px;

  @include themed() {
    background: t($bg);
    color: t($primary);
  }
}

.row {
  display: flex;
  column-gap: 12px;
  align-items: flex-start;
}

.title {
  @extend %font-body-medium;
  margin-bottom: 4px;
}

.subtitle {
  @extend %font-caption-regular;
  @include themed() {
    color: t($grey-60);
  }
}

.spinner {
  margin-top: 2px;

  :deep(.container) {
    height: 24px;
    width: 24px;
  }

  :deep(.spinner) {
    width: 16px;
    height: 16px;
    border-width: 2px;
  }
}
</style>
